<template>
  <article v-if="showAlert" class="px-2 pb-4" data-testid="thank-you-alert">
    <div class="ant-alert-warning thank-you-alert">
    <span class="custom-alert-icon ">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36">
        <path
          fill="currentColor"
          d="M18 2.5c-8.82 0-16 6.28-16 14s7.18 14 16 14a18 18 0 0 0 4.88-.68l5.53 3.52a1 1 0 0 0 1.54-.84v-6.73a13 13 0 0 0 4-9.27C34 8.78 26.82 2.5 18 2.5m10.29 22.11a1 1 0 0 0-.32.73v5.34l-4.38-2.79a1 1 0 0 0-.83-.11a16 16 0 0 1-4.76.72c-7.72 0-14-5.38-14-12s6.28-12 14-12s14 5.38 14 12a11.08 11.08 0 0 1-3.71 8.11"
          class="clr-i-outline clr-i-outline-path-1"
        />
        <path
          fill="currentColor" d="M18 20.63a1 1 0 0 0 1-1V8.48a1 1 0 1 0-2 0v11.13a1 1 0 0 0 1 1.02"
          class="clr-i-outline clr-i-outline-path-2"
        />
        <circle
          cx="18" cy="24.04" r="1.33" fill="currentColor"
          class="clr-i-outline clr-i-outline-path-3"
        />
        <path
          fill="none" d="M0 0h36v36H0z"/>
      </svg>
        </span>
      <div>
        <header>
          <h3>{{ $t('Disclaimer') }}</h3>
        </header>
        <div class="alert-content">
          <p
            v-if="isNotTrustyCDN"
            v-html="$t('ThankYouForUsingAsiansGroupCDN')"
          />
          <p
            v-else
            v-html="$t('ThankYouForUsingTrustyCDN')"
          />
        </div>
      </div>
      <div>
        <button
          class="custom-alert-dismiss"
          data-testid="dismiss-alert"
          @click="handleCloseAlert"
        >
          <a-tooltip
            :title="$t('DisclaimerDismiss')"
            placement="bottomRight"
          >
            <CIcon name="cil-x-circle" height="22" width="22"/>
          </a-tooltip>
        </button>
      </div>
    </div>
  </article>
</template>

<style scoped lang="scss">

.thank-you-alert {
  display: flex;
  gap: 8px;
  padding: 1rem;
  border-radius: 4px;

  .custom-alert-icon {
    color: var(--warning);
  }

  .custom-alert-dismiss {
    background: none;
    border: none !important;
    cursor: pointer;
  }

  h3 {
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: .5rem;
    margin-top: .15rem;
  }

  .alert-content {
    p {
      font-size: .875rem;
      font-weight: 400;
      margin-bottom: .25rem;
      color: #666;
    }
  }
}
</style>


<script>
import { mapGetters } from "vuex";
import Cookies from 'js-cookie';

const COOKIE_NAME = 'THANK_YOU_ALERT_DISMISSED';

export default {
  name: 'ThankYouAlert',
  data() {
    return {
      showAlert: true,
    };
  },
  computed: {
    ...mapGetters(["isNotTrustyCDN"]),
  },
  created() {
    this.checkAlertVisibility();
  },
  methods: {
    checkAlertVisibility() {
      const dismissedDate = Cookies.get(COOKIE_NAME);
      if (dismissedDate) {
        const dismissed = new Date(dismissedDate);
        const now = new Date();

        // Check if we're in a new month compared to when it was dismissed
        const isNewMonth = now.getFullYear() > dismissed.getFullYear() ||
          (now.getFullYear() === dismissed.getFullYear() && now.getMonth() > dismissed.getMonth());

        if (!isNewMonth) {
          this.showAlert = false;
        }
      }
    },
    handleCloseAlert() {
      // Set cookie with current date
      const now = new Date();

      // Calculate expiration date: first day of next month
      const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);

      Cookies.set(COOKIE_NAME, now.toISOString(), {
        expires: nextMonth, // Cookie expires at the beginning of next month
        path: '/'
      });

      this.showAlert = false;
    }
  }
};
</script>
